import { gql } from '@apollo/client';
import NotificationMessageDTO from './fragments/notificationMessageDTO.fragment.notification';

export default gql`
  query searchNotifications($pageSize: Int!, $token: String, $query: String!) {
    searchNotifications(
      input: { pageSize: $pageSize, token: $token, query: $query }
    ) {
      token
      notifications {
        ...NotificationMessageDTO
      }
    }
  }
  ${NotificationMessageDTO}
`;
